import React from 'react';
import { useLanguage } from '../../helpers/language-context';
import { renderHTML } from '../../helpers/render-html';

const SeriousIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#FDA729" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
    <path d="M9 14l2 2 4-4" />
  </svg>
);

const ProtectedIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#FDA729" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const RetaliationIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#FDA729" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M12 8v4" />
    <path d="M12 16h.01" />
  </svg>
);

const Guarantee = () => {
  const { translations } = useLanguage();

  return (
    <section className="bg-[#28357B] text-white py-24 relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex flex-col space-y-8 text-center justify-center items-center mx-auto mb-20">
          <div className="max-w-4xl">
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold leading-tight mb-6">{translations.governance.weCanGuarantee}</h2>
            <p className="text-xl text-gray-300/80 font-light leading-relaxed" dangerouslySetInnerHTML={renderHTML(translations.governance.weCanGuaranteeDesc)} />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div className="flex flex-col items-center text-center space-y-6 group">
            <div className="p-4 rounded-2xl bg-white/5 group-hover:bg-orange-500/10 transition-colors duration-500">
              <SeriousIcon />
            </div>
            <h3 className="text-xl md:text-2xl font-bold tracking-tight">{translations.governance.allDisclosuresAreTreatedSeriously}</h3>
            <p className="text-lg text-gray-400 font-light leading-relaxed" dangerouslySetInnerHTML={renderHTML(translations.governance.allDisclosuresAreTreatedSeriouslyDesc)} />
          </div>

          <div className="flex flex-col items-center text-center space-y-6 group">
            <div className="p-4 rounded-2xl bg-white/5 group-hover:bg-orange-500/10 transition-colors duration-500">
              <ProtectedIcon />
            </div>
            <h3 className="text-xl md:text-2xl font-bold tracking-tight">{translations.governance.whistleblowerIdentitiesAreProtected}</h3>
            <p className="text-lg text-gray-400 font-light leading-relaxed" dangerouslySetInnerHTML={renderHTML(translations.governance.whistleblowerIdentitiesAreProtectedDesc)} />
          </div>

          <div className="flex flex-col items-center text-center space-y-6 group">
            <div className="p-4 rounded-2xl bg-white/5 group-hover:bg-orange-500/10 transition-colors duration-500">
              <RetaliationIcon />
            </div>
            <h3 className="text-xl md:text-2xl font-bold tracking-tight">{translations.governance.kssbForbidsRetaliationAgainstWhistleblowers}</h3>
            <p className="text-lg text-gray-400 font-light leading-relaxed" dangerouslySetInnerHTML={renderHTML(translations.governance.kssbForbidsRetaliationAgainstWhistleblowersDesc)} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
